/**
 * Fallback source for multi-page scaffold files when the sandbox is missing them.
 * Keeps the DayOne sandbox build working without changing Edge Functions.
 * Must match the API expected by Shell.tsx, Dashboard.tsx, Items.tsx, ItemForm.tsx, App.tsx.
 */

export const MULTI_PAGE_ROUTER_TS = `export type Route = "dashboard" | "items" | "new";

export function getRoute(): Route {
  const hash = (window.location.hash || "#/dashboard").replace("#/", "");
  if (hash === "items") return "items";
  if (hash === "new") return "new";
  return "dashboard";
}

export function go(route: Route) {
  window.location.hash = "#/" + route;
}
`;

export const MULTI_PAGE_STORAGE_TS = `export type Item = {
  id: string;
  name: string;
  notes: string;
  createdAt: string;
};

const KEY = "dayone_app_items_v1";

function uid() {
  return Math.random().toString(16).slice(2) + "-" + Date.now().toString(16);
}

export function loadItems(): Item[] {
  const raw = localStorage.getItem(KEY);
  if (!raw) {
    const seed: Item[] = [
      { id: uid(), name: "Example item", notes: "Edit or delete me.", createdAt: new Date().toISOString() },
    ];
    localStorage.setItem(KEY, JSON.stringify(seed));
    return seed;
  }
  try {
    return JSON.parse(raw) as Item[];
  } catch {
    return [];
  }
}

export function saveItems(items: Item[]) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function addItem(input: { name: string; notes: string }) {
  const items = loadItems();
  const next: Item = { id: uid(), name: input.name, notes: input.notes, createdAt: new Date().toISOString() };
  const out = [next, ...items];
  saveItems(out);
  return next;
}

export function deleteItem(id: string) {
  const items = loadItems().filter((x) => x.id !== id);
  saveItems(items);
}
`;
